import { Injectable } from '@angular/core';
import { Headers, Response } from '@angular/http';
import { each, extend } from 'lodash';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class ApiService {
  public key: string;
  baseUrl = environment.serverUrl;

  constructor() {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.key = currentUser && currentUser.key;
  }
}

export function parseErrors(err) {
  let errors = [];
  if (err.status >= 500) {
    errors.push(err.statusText);
  } else if (typeof err._body === 'string') {
    try {
      let body = JSON.parse(err._body);
      if (body.detail) {
        errors.push(body.detail);
      } else {
        errors = rescurseErrorObject(body, errors);
      }
    } catch (e) { }
  } else {
    errors.push(err);
  }
  return errors;
}
function rescurseErrorObject(obj, errors) {
  each(obj, (msg, key) => {
    if (Array.isArray(msg)) {
      errors = errors.concat(msg.map(err => (key === 'non_field_errors' ? '' : key.replace(/_/g, ' ') + ': ') + err));
    } else if (typeof msg === 'string') {
      errors.push((key === 'non_field_errors' ? '' : key.replace(/_/g, ' ') + ': ') + msg);
    } else if (typeof msg === 'object') {
      errors = rescurseErrorObject(msg, errors);
    }
  });
  return errors;
}

export function requestHeaders(xhr: XMLHttpRequest = null) {
  let headers = new Headers();
  let headersObj = {};
  if (!xhr) {
    extend(headersObj, {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    });
  }

  let currentUser = JSON.parse(localStorage.getItem('currentUser'));
  let key = currentUser && currentUser.key;
  let tokenString = 'Token ' + key;
  headersObj['Authorization'] = tokenString;
  headersObj['x-app-uuid'] = '560f2e3b-b3ae-4d18-9164-bffeefbe6c63';

  each(headersObj, (value: string, header: string) => {
    if (xhr) {
      xhr.setRequestHeader(header, value);
    } else {
      headers.append(header, value);
    }
  });
  return headers;
}

export function handleError(error: Response | any) {
  return Observable.throw(parseErrors(error));
}



// WEBPACK FOOTER //
// ./src/app/shared/api.service.ts